
import React from "react";
import { VariantsManager } from "@/components/variants/VariantsManager";

export default function Variants() {
  return (
    <div className="container mx-auto px-4 py-6">
      <VariantsManager />
    </div>
  );
}
